import Header from 'src/components/header/header';
import Footer from 'src/components/footer/footer';
import Head from 'next/head';
import React from 'react';
import Router from 'next/router';
import { AppProps } from 'next/app';
import { TokenContext, TokenContextProvider } from 'src/components/token-store';
import { SwaggerContextProvider } from 'src/components/liveapi/swaggerContext';
import { StatusContextProvider } from 'src/components/status-store';
import * as developerPortalStyles from 'src/styles/developerportal.styles';
import { generateCommonHeadTags } from '@domain-group/fe-head-tags';

import * as gtag from 'src/lib/gtag';

// track pageview when route changes
Router.events.on('routeChangeComplete', (url) => gtag.pageview(url));

function MyApp({ Component, pageProps }: AppProps): any {
  return (
    <>
      <Head>{generateCommonHeadTags()}</Head>
      <TokenContextProvider>
        <SwaggerContextProvider>
          <TokenContext.Consumer>
            {(tokenContext) => (
              <StatusContextProvider accessToken={tokenContext.accessToken}>
                <div css={developerPortalStyles.mainGrid}>
                  <div css={developerPortalStyles.mainGridHeader}>
                    <Header />
                  </div>
                  <div css={developerPortalStyles.mainGridBody}>
                    <Component {...pageProps} />
                  </div>
                  <div css={developerPortalStyles.mainGridFooter}>
                    <Footer />
                  </div>
                </div>
              </StatusContextProvider>
            )}
          </TokenContext.Consumer>
        </SwaggerContextProvider>
      </TokenContextProvider>
    </>
  );
}

export default MyApp;
